import type { ApiResult } from '@klinik/shared';

const BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787';

async function request<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  try {
    const res = await fetch(`${BASE}${path}`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
      ...init,
    });
    const body = (await res.json().catch(() => null)) as ApiResult<T> | null;
    if (body && typeof body === 'object' && 'ok' in body) return body;
    return { ok: false, error: { code: 'internal_error', message: `HTTP ${res.status}` } };
  } catch {
    return { ok: false, error: { code: 'internal_error', message: 'Network error' } };
  }
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PATCH', body: body === undefined ? undefined : JSON.stringify(body) }),
  del: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};

export const googleLoginUrl = () => `${BASE}/auth/google/login`;
